export default class ForbiddenWordValidationResult {
  constructor(public word: string, public error: string | null) {}
}
